import PropTypes from "prop-types";

/**
 *
 * @param {string} width
 * @param {string} height
 * @param {string} fill
 * @returns {JSX.Element}
 * @constructor
 */
export default function Minus({ height = '2', width = '10', fill = 'none' }) {
    return (
        <svg width={width} height={height} viewBox="0 0 10 2" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M0 1H10" stroke="black" stroke-width="2"/>
        </svg>
    )
}

Minus.PropTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
}
